import React, { useEffect } from 'react';
import Navbar from "../layouts/Navbar";
import TagLine from "../layouts/TagLine";
import Intro from "../layouts/Intro";
import Section from "../layouts/Section";
import Footer from "../layouts/Footer";
import { Link, useHistory } from "react-router-dom";

const Landing = () => {
    const history = useHistory();
    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("user"));
        if (user) {
            //console.log("lol")
            history.push(`/home`);
        }
    }, [])
    return (
        <>
            {/* Navbar */}
            <Navbar />
            {/* tagline */}
            <TagLine />
            {/* Intro */}
            <Intro />
            {/* Section */}
            <Section />
            {/* Footer */}
            <Footer />
        </>
    )
}

export default Landing;